import { Stack, Box } from '@n26/nxd'
import { FooterNavigationItems } from '@components/Footer/FooterNavigationItems'
import { OneTrustLanguageManager } from '@components/OneTrustCookieNote/OneTrustLanguageManager'
import { OneTrustPopupButton } from '@components/OneTrustCookieNote/OneTrustPopupButton'
import { useCookieNote } from '@hooks/useCookieNote'
import { LocaleSwitcherMenuDropdown } from '@components/LocaleSwitcherMenuDropdown'
import type { FooterColophonData } from '@helpers/getFooter'
import { Link } from '@components/Link'
import { useLocaliseString } from '@hooks/useLocaliseString'
import { APP_FEATURES } from '@constants/features'
import { useGetCountryLanguage } from '@hooks/useGetCountryLanguage'
import { useGetLocale } from '@hooks/useGetLocale'

export const buttonLinkClassName =
  'flex flex-row rounded-lg px-8 py-8 hover:bg-neutral hover:opacity-50 text-right hover:text-neutral'

export const LowerFooter = ({ data }: { data: FooterColophonData }) => {
  const { allowCookieNote, openCookieNote } = useCookieNote()
  const localiseString = useLocaliseString()
  const { language } = useGetCountryLanguage()
  const locale = useGetLocale()

  return (
    <div className='py-16 px-16 md:px-24 bg-teal relative text-neutral-tertiary text-12'>
      <Box
        display='flex'
        flexDirection={{ mobile: 'column', desktop: 'row' }}
        alignItems={{ desktop: 'center', mobile: 'flex-start' }}
        className='max-w-container mx-auto'
      >
        <Stack
          space={{ mobile: '8', desktop: '24' }}
          direction={{ mobile: 'vertical', desktop: 'horizontal' }}
          align={{ desktop: 'center', mobile: 'flex-start' }}
        >
          <Link
            url={APP_FEATURES.LegalDocuments[language]}
            baseUrl={`/${locale}`}
            className={buttonLinkClassName}
          >
            {localiseString('LegalDocuments')}
          </Link>
          {data && (
            <FooterNavigationItems
              linkStyles={buttonLinkClassName}
              navigationItems={data}
              hasEndIcon
            />
          )}
        </Stack>

        <Stack.Separator />
        <Stack space={{ mobile: '8', desktop: '24' }}>
          <Box alignItems='center'>
            {allowCookieNote && (
              <OneTrustLanguageManager>
                <OneTrustPopupButton
                  handleClick={openCookieNote}
                  className={buttonLinkClassName}
                >
                  {localiseString('OneTrustPopupButton')}
                </OneTrustPopupButton>
              </OneTrustLanguageManager>
            )}
          </Box>
        </Stack>
        <Stack space={{ mobile: '8', desktop: '24' }}>
          <p className='p-8'>© N26 AG {new Date().getFullYear()}</p>
        </Stack>
        <LocaleSwitcherMenuDropdown isFooter />
      </Box>
    </div>
  )
}
